import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, withRouter, Link } from 'react-router-dom';
import AsrDeploy from './AsrDeploy';
import $ from 'jquery';
import ASRDemo from './ASRDemo';
import AsrBuild from './AsrBuild';

class AsrDeployTab extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;

      var path = window.origin + "/platform/cloud-asr/test-and-deploy";
      var path1 = window.origin + "/platform/cloud-asr/test-and-deploy/";
      if (currentPath === path || currentPath === path1) {
        $("#asr-build-tab").addClass('active');
      } else if (currentPath.includes("/cloud-asr/test-and-deploy/test")) {
        $("#asr-test-tab").addClass('active');
      } else if (currentPath.includes("/cloud-asr/test-and-deploy/deploy")) {
        $("#asr-deploy-tab").addClass('active');
      }
      else {
        $("#" + localStorage.getItem("last-project-settings-tab")).addClass('active')
      }
      $("#asr-build-tab,#asr-test-tab, #asr-deploy-tab")
        .on("click", function () {
          $("#asr-build-tab,#asr-test-tab, #asr-deploy-tab")
            .removeClass('active');
          localStorage.setItem("last-project-settings-tab", $(this)[0].id);

          $(this).addClass('active')

        })
    })();
  }
  render() {
    return (
      <Router basename={window.contextPath}>
        <div id="tabPage">
          <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

            <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
            <title> Dheeyantra | Clusters Details</title>
            {/* Font Awesome Icons */}
            <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
            {/* IonIcons */}
            <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
            <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
            {/* Theme style */}
            <link rel="stylesheet" href="assets/css/adminlte.css" />
            <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
            <link rel="stylesheet" href="assets/css/custom-style.css" />
            <link rel="stylesheet" href="assets/css/styles.css" />
            <link rel="stylesheet" href="assets/css/custom-style.css" />
            <div className="content-header" >
              <div className="container-fluid">
                <div className="row">
                  <div className="col-sm-5">
                    <h1 className="m-0 page-title">Test &amp; Deploy </h1>
                    <h6 className="taglineTxt">Build Interact &amp; Distribute</h6>

                  </div>

                </div>
              </div>
            </div>
            <div className="container-fluid" style={{ marginLeft: '10px' }}>
              <div className="border-bottom"></div>
              {/* Nav tabs */}
              <div className="tab-class" >
                <ul className="nav nav-tabs border-bottom navCluster">
                  <Link to="/cloud-asr/test-and-deploy" className="nav-item" data-toggle="tab"
                    style={{ textDecoration: 'none' }}>
                    <li className="nav-link" id="asr-build-tab">Build</li>
                  </Link>
                  <Link to="/cloud-asr/test-and-deploy/test" className="nav-item" data-toggle="tab"
                    style={{ textDecoration: 'none' }}>
                    <li className="nav-link" id="asr-test-tab">Test</li>
                  </Link>
                  <Link to="/cloud-asr/test-and-deploy/deploy" className="nav-item" data-toggle="tab"
                    style={{ textDecoration: 'none' }}>
                    <li className="nav-link" id="asr-deploy-tab">Deploy</li>
                  </Link>
                </ul>
              </div>
            </div>
          </div>
          <Switch>
            <Route path="/cloud-asr/test-and-deploy/deploy" component={AsrDeploy}></Route>
            <Route path="/cloud-asr/test-and-deploy/test" component={ASRDemo}></Route>
            <Route path="/cloud-asr/test-and-deploy" component={AsrBuild}></Route>
          </Switch>
        </div>
      </Router>

    );
  }
}
export default AsrDeployTab;


// WEBPACK FOOTER //
// ./src/asrUi/AsrDeployTab.js